// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.step-1__block[data-v-03c4fddf] {\n  margin-top: 20px;\n}\n.step-1__btn[data-v-03c4fddf] {\n  max-width: 170px;\n  margin-left: auto;\n  padding: 0 10px;\n  line-height: 1.43;\n  white-space: normal;\n}\n.payout-block__list[data-v-03c4fddf] {\n  padding-left: 30px;\n}\n@media (max-width: 500px) {\n.step-1__btn[data-v-03c4fddf] {\n    max-width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
